import { exotics } from "$lib/assets/lists/exotics";
/**
 * Given a vehicle's year, make, and model, this
 * function will determine the correct order type id for the vehicle.
 * The order type id is a string that represents the type of vehicle.
 * The types are:
 * 2: standard
 * 3: classic
 * 4: exotic
 * The function will return the order type id as a string.
 * If the vehicle's year, make, or model are not provided, the function
 * will log a message to the console and not return anything.
 * @param vehicle_year the year of the vehicle
 * @param vehicle_make the make of the vehicle
 * @param vehicle_model the model of the vehicle
 * @returns the order type id
 */
export async function determineOrderType(vehicle_year: number, vehicle_make: string, vehicle_model: string) {
    let order_type: string;
    const currentYear = new Date().getFullYear();
    if (vehicle_year && vehicle_make && vehicle_model) {
        if (vehicle_year < currentYear - 20) {
            order_type = "3"; // classic
            return order_type;
        } else if (exotics.includes(vehicle_model)) {
            order_type = "4"; // exotic
            return order_type;
        } else {
            order_type = "2"; // standard
            return order_type;
        }
    } else {
        console.log("need make model and year");
    }
}

/**
 * Given an order type id, this function will return the human-readable
 * equivalent for the type.
 * The order type id is a string that represents the type of vehicle.
 * The types are:
 * 2: standard
 * 3: classic
 * 4: exotic
 * The function will return the human-readable equivalent as a string.
 * If the order type id is not recognized, the function will return "Standard".
 * @param type the order type id
 * @returns the human-readable equivalent of the order type id
 */
export function orderTypeToEnglish(type: string) {
    switch (type) {
        case "2":
            return "Standard";
        case "3":
            return "Classic";
        case "4":
            return "Exotic";
        default:
            return "Standard";
    }
}
